"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasStockFromAvailableBusinesses = exports.hasStock = void 0;
const config_1 = require("./config");
const envToBusinessUnit_1 = require("./envToBusinessUnit");
const hasStock = (reseller) => {
    const { availableBusinessUnits } = reseller.item;
    const brand = envToBusinessUnit_1.envToBusinessUnit[config_1.envConfig.currentBrand];
    return (0, exports.hasStockFromAvailableBusinesses)(availableBusinessUnits, brand);
};
exports.hasStock = hasStock;
const hasStockFromAvailableBusinesses = (availableBusinessUnits, businessUnit) => {
    var _a;
    if (availableBusinessUnits &&
        Object.keys(availableBusinessUnits).length &&
        config_1.envConfig.currentBrand) {
        return !!((_a = availableBusinessUnits[businessUnit]) === null || _a === void 0 ? void 0 : _a.hasStock);
    }
    return false;
};
exports.hasStockFromAvailableBusinesses = hasStockFromAvailableBusinesses;
